// extracted by mini-css-extract-plugin
export default {"clickable":"NextButtonBlock_clickable__sjwGs","button":"NextButtonBlock_button__jCxNG","text":"NextButtonBlock_text__2sbqU"};